import { providersService } from '../services';

export const StageCmp = async () => {
  const { data } = await providersService.getStageCmp();
  return data;
};
